// Fire-and-forget reporting to the activity log (netlify/functions/log-
// activity.ts) so the admin panel has something to show beyond raw chain
// tables. This is a best-effort convenience log, not a source of truth —
// it's called *after* the user's own wallet has already signed and
// broadcast a transaction, purely to make that activity visible in one
// place. A failure here must never surface to the user or block anything;
// their real transaction already went through regardless of whether this
// succeeds.

export type ActivityType =
  | "mint_plain"
  | "mint_backed_create"
  | "mint_backed_deposit"
  | "mint_drop"
  | "drop_created"
  | "redeem"
  | "list_for_sale"
  | "buy"
  | "collection_created"
  | "schemas_created"
  | "templates_created"
  | "mint_polygon";

export interface ActivityEvent {
  type: ActivityType;
  account: string;
  collectionName?: string;
  templateId?: number | string;
  assetId?: string;
  dropId?: string;
  amount?: string;
  txId?: string;
  note?: string;
}

export function logActivity(event: ActivityEvent): void {
  fetch("/.netlify/functions/log-activity", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(event),
  }).catch(() => {
    /* best-effort only — never let a logging failure affect the user */
  });
}
